// extracted by mini-css-extract-plugin
module.exports = {"loading-content":"Loader_loading-content__26G1H"};